import { BASE_PATH as R, BaseAPI as y, operationServerMap as g } from "../base.js";
import { DUMMY_BASE_URL as E, assertParamExists as l, createRequestFunction as m, serializeDataIfNeeded as V, setSearchParams as C, toPathString as v } from "../common.js";
import p from "axios";
var B = function(a) {
  return {
    merchantCreditExchangeRecordBatchVerifyExchangeRecord: async (n, c = {}) => {
      l("merchantCreditExchangeRecordBatchVerifyExchangeRecord", "requestBody", n);
      const d = new URL("/merchant/mms/credit_exchange_record/batch_verify", E);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "PATCH",
        ...r,
        ...c
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", C(d, o);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...h,
        ...c.headers
      }, e.data = V(n, e, a), {
        url: v(d),
        options: e
      };
    },
    merchantCreditExchangeRecordCancelVerifyExchangeRecord: async (n, c = {}) => {
      l("merchantCreditExchangeRecordCancelVerifyExchangeRecord", "exchangeRecordId", n);
      const d = "/merchant/mms/credit_exchange_record/{exchangeRecordId}/cancel_verify".replace("{exchangeRecordId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "PATCH",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordCreateExchangeRecord: async (n, c = {}) => {
      l("merchantCreditExchangeRecordCreateExchangeRecord", "creditExchangeRecordDTO", n);
      const d = new URL("/merchant/mms/credit_exchange_record", E);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...c
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", C(d, o);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...h,
        ...c.headers
      }, e.data = V(n, e, a), {
        url: v(d),
        options: e
      };
    },
    merchantCreditExchangeRecordGetByVoucherCode: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetByVoucherCode", "voucherCode", n);
      const d = "/merchant/mms/credit_exchange_record/voucher/{voucherCode}".replace("{voucherCode}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordGetByVoucherCode2B: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetByVoucherCode2B", "voucherCode", n);
      const d = "/merchant/mms/credit_exchange_record/voucher_2b/{voucherCode}".replace("{voucherCode}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordGetExchangeRecordById: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetExchangeRecordById", "exchangeRecordId", n);
      const d = "/merchant/mms/credit_exchange_record/{exchangeRecordId}".replace("{exchangeRecordId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordGetExchangeRecordById2B: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetExchangeRecordById2B", "exchangeRecordId", n);
      const d = "/merchant/mms/credit_exchange_record/2b/{exchangeRecordId}".replace("{exchangeRecordId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordGetExchangeRecordPage: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetExchangeRecordPage", "creditExchangeRecordPageRequestDTO", n);
      const d = new URL("/merchant/mms/credit_exchange_record/page", E);
      let r;
      a && (r = a.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...c
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", C(d, o);
      let h = r && r.headers ? r.headers : {};
      return e.headers = {
        ...t,
        ...h,
        ...c.headers
      }, e.data = V(n, e, a), {
        url: v(d),
        options: e
      };
    },
    merchantCreditExchangeRecordGetPendingExchangeRecords: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetPendingExchangeRecords", "customerUserId", n);
      const d = "/merchant/mms/credit_exchange_record/pending/{customerUserId}".replace("{customerUserId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordGetSensitiveExchangeDetail: async (n, c = {}) => {
      l("merchantCreditExchangeRecordGetSensitiveExchangeDetail", "exchangeRecordId", n);
      const d = "/merchant/mms/credit_exchange_record/sensitive/detail/{exchangeRecordId}".replace("{exchangeRecordId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "GET",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    },
    merchantCreditExchangeRecordInvalidExchangeRecord: async (n, c, d = {}) => {
      l("merchantCreditExchangeRecordInvalidExchangeRecord", "exchangeRecordId", n), l("merchantCreditExchangeRecordInvalidExchangeRecord", "reason", c);
      const r = "/merchant/mms/credit_exchange_record/{exchangeRecordId}/invalid".replace("{exchangeRecordId}", encodeURIComponent(String(n))), e = new URL(r, E);
      let t;
      a && (t = a.baseOptions);
      const o = {
        method: "PATCH",
        ...t,
        ...d
      }, h = {}, s = {};
      c !== void 0 && (s.reason = c), C(e, s);
      let i = t && t.headers ? t.headers : {};
      return o.headers = {
        ...h,
        ...i,
        ...d.headers
      }, {
        url: v(e),
        options: o
      };
    },
    merchantCreditExchangeRecordVerifyExchangeRecord: async (n, c = {}) => {
      l("merchantCreditExchangeRecordVerifyExchangeRecord", "exchangeRecordId", n);
      const d = "/merchant/mms/credit_exchange_record/{exchangeRecordId}/verify".replace("{exchangeRecordId}", encodeURIComponent(String(n))), r = new URL(d, E);
      let e;
      a && (e = a.baseOptions);
      const t = {
        method: "PATCH",
        ...e,
        ...c
      }, o = {};
      C(r, {});
      let h = e && e.headers ? e.headers : {};
      return t.headers = {
        ...o,
        ...h,
        ...c.headers
      }, {
        url: v(r),
        options: t
      };
    }
  };
}, x = function(a) {
  const n = B(a);
  return {
    async merchantCreditExchangeRecordBatchVerifyExchangeRecord(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordBatchVerifyExchangeRecord(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordBatchVerifyExchangeRecord"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordCancelVerifyExchangeRecord(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordCancelVerifyExchangeRecord(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordCancelVerifyExchangeRecord"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordCreateExchangeRecord(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordCreateExchangeRecord(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordCreateExchangeRecord"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetByVoucherCode(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetByVoucherCode(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetByVoucherCode"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetByVoucherCode2B(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetByVoucherCode2B(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetByVoucherCode2B"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetExchangeRecordById(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetExchangeRecordById(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetExchangeRecordById"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetExchangeRecordById2B(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetExchangeRecordById2B(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetExchangeRecordById2B"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetExchangeRecordPage(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetExchangeRecordPage(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetExchangeRecordPage"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetPendingExchangeRecords(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetPendingExchangeRecords(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetPendingExchangeRecords"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordGetSensitiveExchangeDetail(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordGetSensitiveExchangeDetail(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordGetSensitiveExchangeDetail"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    },
    async merchantCreditExchangeRecordInvalidExchangeRecord(c, d, r) {
      var e, t;
      const o = await n.merchantCreditExchangeRecordInvalidExchangeRecord(c, d, r), h = (e = a == null ? void 0 : a.serverIndex) !== null && e !== void 0 ? e : 0, s = (t = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordInvalidExchangeRecord"]) === null || t === void 0 || (t = t[h]) === null || t === void 0 ? void 0 : t.url;
      return (i, u) => m(o, p, R, a)(i, s || u);
    },
    async merchantCreditExchangeRecordVerifyExchangeRecord(c, d) {
      var r, e;
      const t = await n.merchantCreditExchangeRecordVerifyExchangeRecord(c, d), o = (r = a == null ? void 0 : a.serverIndex) !== null && r !== void 0 ? r : 0, h = (e = g["MerchantCreditExchangeRecordApi.merchantCreditExchangeRecordVerifyExchangeRecord"]) === null || e === void 0 || (e = e[o]) === null || e === void 0 ? void 0 : e.url;
      return (s, i) => m(t, p, R, a)(s, h || i);
    }
  };
}, P = function(a, n, c) {
  const d = x(a);
  return {
    merchantCreditExchangeRecordBatchVerifyExchangeRecord(r, e) {
      return d.merchantCreditExchangeRecordBatchVerifyExchangeRecord(r.requestBody, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordCancelVerifyExchangeRecord(r, e) {
      return d.merchantCreditExchangeRecordCancelVerifyExchangeRecord(r.exchangeRecordId, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordCreateExchangeRecord(r, e) {
      return d.merchantCreditExchangeRecordCreateExchangeRecord(r.creditExchangeRecordDTO, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetByVoucherCode(r, e) {
      return d.merchantCreditExchangeRecordGetByVoucherCode(r.voucherCode, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetByVoucherCode2B(r, e) {
      return d.merchantCreditExchangeRecordGetByVoucherCode2B(r.voucherCode, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetExchangeRecordById(r, e) {
      return d.merchantCreditExchangeRecordGetExchangeRecordById(r.exchangeRecordId, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetExchangeRecordById2B(r, e) {
      return d.merchantCreditExchangeRecordGetExchangeRecordById2B(r.exchangeRecordId, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetExchangeRecordPage(r, e) {
      return d.merchantCreditExchangeRecordGetExchangeRecordPage(r.creditExchangeRecordPageRequestDTO, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetPendingExchangeRecords(r, e) {
      return d.merchantCreditExchangeRecordGetPendingExchangeRecords(r.customerUserId, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordGetSensitiveExchangeDetail(r, e) {
      return d.merchantCreditExchangeRecordGetSensitiveExchangeDetail(r.exchangeRecordId, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordInvalidExchangeRecord(r, e) {
      return d.merchantCreditExchangeRecordInvalidExchangeRecord(r.exchangeRecordId, r.reason, e).then((t) => t(c, n));
    },
    merchantCreditExchangeRecordVerifyExchangeRecord(r, e) {
      return d.merchantCreditExchangeRecordVerifyExchangeRecord(r.exchangeRecordId, e).then((t) => t(c, n));
    }
  };
}, S = class extends y {
  merchantCreditExchangeRecordBatchVerifyExchangeRecord(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordBatchVerifyExchangeRecord(a.requestBody, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordCancelVerifyExchangeRecord(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordCancelVerifyExchangeRecord(a.exchangeRecordId, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordCreateExchangeRecord(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordCreateExchangeRecord(a.creditExchangeRecordDTO, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetByVoucherCode(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetByVoucherCode(a.voucherCode, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetByVoucherCode2B(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetByVoucherCode2B(a.voucherCode, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetExchangeRecordById(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetExchangeRecordById(a.exchangeRecordId, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetExchangeRecordById2B(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetExchangeRecordById2B(a.exchangeRecordId, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetExchangeRecordPage(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetExchangeRecordPage(a.creditExchangeRecordPageRequestDTO, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetPendingExchangeRecords(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetPendingExchangeRecords(a.customerUserId, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordGetSensitiveExchangeDetail(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordGetSensitiveExchangeDetail(a.exchangeRecordId, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordInvalidExchangeRecord(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordInvalidExchangeRecord(a.exchangeRecordId, a.reason, n).then((c) => c(this.axios, this.basePath));
  }
  merchantCreditExchangeRecordVerifyExchangeRecord(a, n) {
    return x(this.configuration).merchantCreditExchangeRecordVerifyExchangeRecord(a.exchangeRecordId, n).then((c) => c(this.axios, this.basePath));
  }
};
export {
  S as MerchantCreditExchangeRecordApi,
  B as MerchantCreditExchangeRecordApiAxiosParamCreator,
  P as MerchantCreditExchangeRecordApiFactory,
  x as MerchantCreditExchangeRecordApiFp
};

//# sourceMappingURL=merchant-credit-exchange-record-api.js.map